module.exports = __webpack_public_path__ + "static/media/arrow_back_green.d26f285b.svg";